import { AnimatePresence } from 'motion/react'
import { useContextPanels } from '../../contexts/panelsContext'
import { useContextMotifDetails } from '../../contexts/motifDetailsContext'
import { Tag } from '../../constants/tags'
import { UIElement } from '../../types/UIElements'
import TagFilterOverlay from './TagFilterOverlay'

const TagFilter = () => {
  const { isPanelOpen, overlayVisible, hideOverlay, closeAll } = useContextPanels()
  const { applyTagFilter } = useContextMotifDetails()
  // picking a theme hides the overlay, but the filter stays open in the filter bar
  const isVisible = isPanelOpen(UIElement.TAGFILTER) && overlayVisible

  const handleSelect = (tag: Tag) => {
    applyTagFilter(tag)
    hideOverlay()
  }

  const handleCloseTagFilter = () => {
    window.history.replaceState(null, '', '/')
    closeAll()
    applyTagFilter(undefined)
  }

  return (
    <AnimatePresence>
      {isVisible ? (
        <TagFilterOverlay key="tag-filter" onSelect={handleSelect} onClose={handleCloseTagFilter} />
      ) : null}
    </AnimatePresence>
  )
}

export default TagFilter
